module.exports = __webpack_public_path__ + "static/media/maolanshanicon.a5bd89c5.webp";